import {useMemo} from 'react';

import {filterAccessibleProjects} from '../utils/projectAccess';
import {getAttribute, hasAccess} from '../utils/user-access';
import {useProjectsByOrganization} from './useProjects';

/**
 * Proyectos de la organización que el usuario logueado puede seleccionar:
 * activos y, salvo super-admin u org-admin, solo los asignados en su token.
 * Cualquier selector de proyecto debería salir de aquí y no de la lista cruda.
 *
 * @param idOrganization organización en la ruta
 * @returns la query de proyectos con `data` ya filtrada (ordenada por nombre)
 */
export function useAccessibleProjects(idOrganization: string | undefined) {
  const query = useProjectsByOrganization(idOrganization);

  const data = useMemo(
    () =>
      filterAccessibleProjects(query.data, {
        isOrganizationWide:
          !!hasAccess('super-admin') || !!hasAccess('org-admin'),
        allowedProjectIds: getAttribute<string[]>('projects', []),
      }),
    [query.data],
  );

  return {...query, data};
}
